import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import ShapeTwo from '../../components/shape-two'
import Footer from '../../components/footer'

import bg1 from '../../assets/images/bg.jpg'

import { jobData } from '../../data/job'

import {FiAirplay, FiMapPin, FiArrowRight} from '../../assets/icons/vander'

export default function PageJobApplyForm() {
  return (
    <>
     <Navbar/> 

    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
      <div className="bg-overlay bg-overlay-white"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title">Job Apply Form</h4>
                          <p className="text-muted mb-0">Please, Fill up this job apply form</p>
                      </div>
                  </div>
              </div>

              <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="page-next-level text-sm-end">
                      <ul className="page-next ps-0 mb-0">
                          <li className="list-inline-item"><Link to="/" className="text-uppercase fw-bold text-dark">Home</Link></li>
                          <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Pages</Link></li>
                          <li className="list-inline-item">
                              <span className="text-uppercase text-primary fw-bold">Job Apply Form</span> 
                          </li> 
                      </ul>
                  </div>
              </div>
          </div>
      </div> 
    </section>
    <ShapeTwo/>

    <section className="section">
      <div className="container">
          <div className="row justify-content-center">
              <div className="col-lg-10 col-md-7">
                  <div className="card custom-form border-0">
                      <div className="card-body p-0">
                          <form className="rounded shadow p-4">
                              <div className="row">
                                  <div className="col-md-6">
                                      <div className="mb-3">
                                          <label className="form-label">Your Name :<span className="text-danger">*</span></label>
                                          <input name="name" id="name" type="text" className="form-control" placeholder="First Name :"/>
                                      </div>
                                  </div>
                                  <div className="col-md-6">
                                      <div className="mb-3">
                                          <label className="form-label">Your Email :<span className="text-danger">*</span></label>
                                          <input name="email" id="email" type="email" className="form-control" placeholder="Your email :"/>
                                      </div> 
                                  </div>
                                  <div className="col-md-6">
                                      <div className="mb-3">
                                          <label className="form-label">Your Phone no. :<span className="text-danger">*</span></label>
                                          <input name="number" id="number" type="number" className="form-control" placeholder="Your phone no. :"/>
                                      </div> 
                                  </div>
                                  <div className="col-md-6">
                                      <div className="mb-3">
                                          <label className="form-label">Job Title :</label>
                                          <input name="subject" id="subject" className="form-control" placeholder="Title :"/>
                                      </div>                                                                               
                                  </div>
                                  <div className="col-md-6">
                                      <div className="mb-3">
                                          <label className="form-label">Types of jobs :</label>
                                          <select className="form-select form-control" id="Sortbylist-Shop">
                                              <option>All Jobs</option>
                                              <option>Full Time</option>
                                              <option>Half Time</option>
                                              <option>Remote</option>
                                              <option>In Office</option>
                                          </select>
                                      </div>
                                  </div>
                                  <div className="col-md-12">
                                      <div className="mb-3">
                                          <label className="form-label">Description :</label>
                                          <textarea name="comments" id="comments" rows="4" className="form-control" placeholder="Describe the job :"></textarea>
                                      </div>
                                  </div>                                    
                                  <div className="col-md-12">
                                      <div className="mb-3">
                                          <label className="form-label">Upload Your Cv / Resume :</label>
                                          <input type="file" className="form-control-file" id="fileupload"/>
                                      </div>                                                                               
                                  </div>
                                  <div className="col-md-12">
                                      <div className="mb-3">
                                          <div className="form-check">
                                              <input className="form-check-input" type="checkbox" id="customCheck1"/>
                                              <label className="form-check-label" htmlFor="customCheck1">I Accept <Link to="#" className="text-primary">Terms And Condition</Link></label>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div className="row">
                                  <div className="col-sm-12">
                                      <input type="submit" id="submit" name="send" className="submitBnt btn btn-primary" value="Apply Now"/>
                                  </div>
                              </div>
                          </form>
                      </div> 
                  </div>

                  <div className="row align-items-end mb-4 pb-2 mt-5">
                      <div className="col-md-8">
                          <div className="section-title text-center text-md-start">
                              <h4 className="title mb-4">Related Jobs</h4>
                              <p className="text-muted mb-0 para-desc">Start work with Leaping. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                          </div>
                      </div>
  
                      <div className="col-md-4 mt-4 mt-sm-0 d-none d-md-block">
                          <div className="text-center text-md-end">
                              <Link to="/page-jobs" className="text-primary">View more Jobs <FiArrowRight className="fea icon-sm"/></Link>
                          </div>
                      </div>
                  </div>
  
                  <div className="row">   
                    {jobData.slice(0,2).map((item,index)=>{
                      return(
                          <div className="col-md-6 col-12 mt-4 pt-2" key={index}>
                              <div className="card border-0 bg-light rounded shadow">
                                  <div className="card-body p-4">
                                      <span className="badge rounded-pill bg-primary float-md-end mb-3 mb-sm-0">{item.jobType}</span>
                                      <h5>{item.title}</h5>
                                      <div className="mt-3">
                                          <span className="text-muted d-block"><FiAirplay className="align-middle text-primary h6 mb-0"/> <Link to="https://1.envato.market/hostick-template" target="_blank" className="text-muted">{item.name}</Link></span>
                                          <span className="text-muted d-block"><FiMapPin className="align-middle text-primary h6 mb-0"/> {item.country}</span>
                                      </div>
                                      
                                      <div className="mt-3">
                                          <Link to={`/page-job-detail/${item.id}`} className="btn btn-primary">View Details</Link>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      )
                    })}
                  </div>
              </div>  
          </div>
      </div>
    </section>
    <Footer/>
    </>
  )
}
